<template>
  <div class="center-btm">
    <div class="center-btm-tool">
      <div class="btm-tabs" :class="{ 'is-disabled': disabled }">
        <div v-for="item in tabs" :key="item.transFileId" :class="{ active: activeId === item.transFileId }"
          class="btm-tabs-item">
          <el-tooltip class="item" effect="dark" placement="top" :content="item.name">
            <div style="display: flex; align-items: center">
              <span class="btm-tabs-item__text" @click="setItem(item)">{{
                item.name
              }}</span>
              <i v-if="share" class="el-icon-close" @click="delItem(item)"></i>
            </div>
          </el-tooltip>
        </div>
        <span v-if="tabs.length" class="line"></span>
      </div>
      <div class="btm-btns">
        <el-tooltip effect="dark" :content="$t('doc-tool.此项禁用时将无法实时获得演示人最新的文档翻页指令')" placement="top"
          v-if="isShowNotDisturb">
          <!-- :class="{'btm-btns-disturb': true, 'btm-btns-disturb__disabled': isShowNotDisturb}"-->
          <div class="btm-btns-disturb">
            <span>{{ $t('doc-tool.跟随翻页') }}</span>
            <el-switch class="disturb-switch" ref="switchRef" v-model="switchDisturb" active-color="#3986ee"
              inactive-color="#5B617E" @change="handleDisturbChange" />
          </div>
        </el-tooltip>

        <template v-if="total && !disabled">
          <!-- <span v-if="type === 1" class="line"></span>
          <el-popconfirm :title = "$t('doc-tool.你确定要删除所有白板吗？')" placement="top">
            <div v-if="type === 1" class="del-whiteboard" slot="reference">
              <i class="el-icon-delete"></i>
              <span>{{$t('doc-tool.删除所有白板')}}</span>
            </div>
          </el-popconfirm> -->
          <span class="line"></span>
          <!-- <div class="pages">
            <i class="el-icon-arrow-left pages-prev" @click="slidePrev"></i>
            <span class="pages-num">{{ page }}/{{ total }}</span>
            <i class="el-icon-arrow-right pages-next" @click="slideNext"></i>
          </div> -->
          <div class="scale">
            <el-tooltip :content="$t('doc-tool.缩小')" placement="top-start">
              <i class="el-icon-minus scale-minus" @click="scaleMinus"></i>
            </el-tooltip>
            <span class="scale-num">{{ scaleText }}%</span>
            <el-tooltip :content="$t('doc-tool.放大')" placement="top-start">
              <i class="el-icon-plus scale-plus" @click="scalePlus"></i>
            </el-tooltip>
          </div>

          <div class="screen">
            <el-tooltip :content="$t(`doc-tool.${tipsFull}`)" placement="top-start">
              <i :class="[screen ? 'icon-suoxiao' : 'icon-screen']" class="iconfont" @click="screenFull"></i>
            </el-tooltip>
          </div>
        </template>
        <el-tooltip :content="$t('doc-tool.视频文档切换')" placement="top-end">
          <div class="header-btn-icon pointer" @click="handelChangeArea">
            <img :src="require('@/svg/change.svg')" />
          </div>
        </el-tooltip>
        <span class="line"></span>

        <div class="arrow" @click="setShow">
          <el-tooltip :content="$t(`doc-tool.${tipsContent}`)" placement="top-start">
            <i :class="{ hide: !showBottom }" class="el-icon-d-arrow-right btm-btns-arrow"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <transition name="collapse">
      <div v-show="showBottom" :style="{ height: calcHeight + 'px' }" class="center-btm-body">
        <el-tooltip effect="dark" :content="$t('doc-tool.需要获取演示权')" placement="top" :disabled="!!share">
          <div :class="{ dis: (!share && type === 1) || (type == 1 && disabled) }"
            :style="{ height: calcHeight - 17 * 2 + 'px' }" class="doc-add-btn" @click="addDoc">
            <i class="iconfont icon-add-doc"></i>
            <div v-if="type === 0">{{ $t('doc-tool.添加文档') }}</div>
            <div v-if="type === 1">{{ $t('doc-tool.添加白板') }}</div>
          </div>
        </el-tooltip>
        <DocThumbs v-if="docs && shareType !== 4" :docs="docs" :page="page" :type="type" :disabled="disabled"
          @baseHeight="baseHeight" @del="delThumbs" @setPage="setPage" />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
// import { Popconfirm } from "element-ui";
import DocThumbs from "./doc-thumbs.vue";
import Role from "@/mixins/role";
import Bus from "@/components/doc/bus";
import { SET_IS_NOT_DISTURB } from "@/store/modules/default";
import { cloudInfo } from "@/api/docRequest/api";
import { getParameter, fullScreen, exitFullscreen } from "@/utils/global";
import { switchMain } from "@/api/liveRequest/liveInfo"
export default {
  name: "docTool",
  components: {
    // [Popconfirm.name]: Popconfirm,
    DocThumbs,
  },
  mixins: [Role],
  props: {
    type: Number,
    tabs: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    activeId: String,
    docs: Object,
    page: Number,
    scaleText: Number,
  },
  data() {
    return {
      calcHeight: 100,
      delayTimer: null,
      screen: false,
      tipsContent: '缩起',
      tipsFull: '全屏',
      switchDisturb: true,
      roomType: 0,
    };
  },
  computed: {
    ...mapState("docInfo", ["showBottom"]),
    ...mapGetters(["shareType"]),
    total() {
      return this.docs?.doc?.pageinfo.length;
    },
    ischangearea() {
      return this.$store.getters.isChangeArea;
    },
    isNotDisturb() {
      return this.$store.state.defaultInfo.isNotDisturb;
    },
    isShowNotDisturb() {
      // hidden
      // this.share === 0 && this.$store.state.defaultInfo.leftToolType === 0 && this.tabs.length
      // disabled
      // this.share === 1
      const leftToolType = this.$store.state.defaultInfo.leftToolType;
      return this.share === 0 && (leftToolType === 0 || leftToolType === 1);
    },
    notDisturbText() {
      return this.switchDisturb ? this.$t('doc-tool.翻页跟随') : this.$t('doc-tool.不跟随');
    },

  },
  watch: {
    isNotDisturb: {
      handler(newVal) {
        // true 跟随
        if (!newVal) {
          this.switchDisturb = true
        } else {
          this.switchDisturb = newVal === 'true'
        }
      },
      immediate: true
    }

  },
  mounted() {
    this.addEvent();
  },
  methods: {
    ...mapMutations("docInfo", ["SET_SHOW_BOTTOM"]),
    handleDisturbChange(val) {
      // this.$emit('setDisturb', !val)
      // this.$emit('setWhiteDisturb', !val)
      this.$store.commit(`${SET_IS_NOT_DISTURB}`, val.toString());
      if (val) {
        cloudInfo(getParameter("roomId"))
          .then((res) => {
            if (res.status === 0) {
              const typeObj = { doc: 0, wb: 1 };
              if (res.data in typeObj) {
                const type = typeObj[res.data];
                this.roomType = type;
                this.$store.commit("SET_LEFTTOOLTYPE", type);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            Bus.$emit('changeDisturb')
          })
      }
      // const message = val ? '文档预览免打扰已开启' : '文档预览免打扰已关闭'
      // this.$message({type: 'success', message})
    },
    baseHeight(height) {
      this.calcHeight = height;
    },
    addEvent() {
      // 全屏监听
      [
        "fullscreenchange",
        "webkitfullscreenchange",
        "mozfullscreenchange",
      ].forEach((item) => {
        window.addEventListener(item, () => this.fullscreenchange());
      });
    },
    fullscreenchange() {
      let isFull =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement;
      if (isFull) {
        console.log('退出全屏')
        this.screen = false;
        document.querySelector(".anchor-center").classList.remove("anchor-center-full");
      }
    },
    /** 
     * 主区域切换
     * 切换时会推送事件: main_layout 1 文档为主 0 视频为主
     * 注意：主动点击切换才调用接口同步 【2022-07-26】
    */
    async handelChangeArea() {
      const key = sessionStorage.getItem(this.$store.getters.mainStatusKey)
      if (key === '1' && this.share) {
        const status = this.ischangearea ? 1 : 0
        const { code, msg } = await switchMain(status, this.$store.getters.liveToken)
        if (code !== 200) {
          return this.$message.error(msg)
        }
      }
      if (this.shareType != 2 && this.shareType != 3) {
        sessionStorage.setItem("oldErea", !this.ischangearea);
      }
      if (!(key === '1' && this.share)) {
        this.$store.commit("SET_ISCHANGEAREA", !this.ischangearea);
      }
      Bus.$emit("ischangearea",this.ischangearea);
    },
    slideNext() {
      this.$emit("slide:next");
    },
    slidePrev() {
      this.$emit("slide:prev");
    },
    scalePlus() {
      this.$emit("scalePlus");
    },
    scaleMinus() {
      this.$emit("scaleMinus");
    },
    setPage(page) {
      this.$emit("setPage", page);
    },
    screenFull() {
      let isFull =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement;
      if (isFull) {
        this.screen = false;
        exitFullscreen();
        document.querySelector(".anchor-center").classList.remove("anchor-center-full");
      } else {
        this.screen = true;
        if (this.ischangearea) {
          fullScreen(document.querySelector(".video-container"));
        } else {
          fullScreen(document.querySelector(".anchor-center"));
          document.querySelector(".anchor-center").classList.add("anchor-center-full");
        }
      }
    },
    setItem(item) {
      if (this.disabled) return;
      this.$emit("tabSelect", item);
    },
    delItem(item) {
      if (this.disabled) return;
      this.$emit("tabDel", item);
    },
    addDoc() {
      if (!this.share && this.type === 1) return;
      if (this.type === 1 && this.total >= 99) {
        return;
      }
      if (this.type === 1 && this.disabled) true;
      if (this.delayTimer) clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => {
        this.$emit("add", this.type);
        this.delayTimer = null;
      }, 300);
    },
    delThumbs(item) {
      this.$emit("delThumbs", item);
    },
    setShow() {
      this.tipsContent = this.showBottom ? this.$t('doc-tool.展开') : this.$t('doc-tool.缩起');
      this.SET_SHOW_BOTTOM(!this.showBottom);
      Bus.$emit("set-show", this.showBottom);
    },
  },
};
</script>

<style lang="scss" scoped>
.center-btm {
  background-color: #1c1e38;
  overflow: hidden;
  position: absolute;
  z-index: 700;
  bottom: 0;
  width: 100%;

  &-tool {
    display: flex;
    height: 30px;
    line-height: 30px;
    background-color: #292c51;
  }

  &-body {
    display: flex;
    align-items: center;
    min-height: 100px;
    overflow: hidden;
    transition: height 0.05s linear;
  }
}

.btm-tabs {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;

  &-item {
    position: relative;
    padding: 0 20px 0 10px;
    display: flex;
    min-width: 20px;
    align-items: center;
    font-size: 12px;
    color: #8a8f99;
    box-sizing: border-box;

    &.active {
      background-color: #1c1e38;
    }

    &__text {
      flex: 1;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
    }

    .el-icon-close {
      position: absolute;
      right: 4px;
      cursor: pointer;
    }
  }

  &.is-disabled {
    .btm-tabs-item {
      pointer-events: none;
    }
  }

  .line {
    margin-left: 12px;
  }
}

.btm-btns {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #acb2bf;

  .btm-btns-disturb {
    margin-right: 30px;

    span {
      margin-right: 10px;
    }

    .disturb-switch {
      width: 28px;
      height: 14px;

      ::v-deep span {
        width: 100% !important;
        height: 100% !important;

        &::after {
          width: 10px;
          height: 10px;
        }
      }
    }

    ::v-deep .el-switch.is-checked .el-switch__core::after {
      margin-left: -10px;
    }
  }
}

.btm-btns-arrow {
  cursor: pointer;
  transform: rotate(90deg);
  transition: all 0.3 ease-in;

  &.hide {
    transform: rotate(-90deg);
  }
}

.pages {
  min-width: 80px;
  display: flex;
  align-items: center;
  margin-left: 20px;

  &-num {
    min-width: 60px;
  }

  &-prev,
  &-next {
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    background: #4c4e75;
    border-radius: 14px;
    cursor: pointer;
  }
}

.scale {
  width: 80px;
  margin-left: 20px;
  margin-right: 10px;

  &-num {
    margin: 0 7px;
    user-select: none;
  }

  &-minus,
  &-plus {
    user-select: none;
    cursor: pointer;
  }
}

.screen {
  width: 30px;
  margin-right: 10px;
  cursor: pointer;
  display: none;

  .icon-screen,
  .icon-suoxiao {
    font-size: 12px;
  }
}

.anchor-center:hover .screen {
  display: block;
}

.arrow {
  width: 40px;
  cursor: pointer;
}

.line {
  width: 1px;
  height: 16px;
  background-color: #1a1e2c;
}

.doc-add-btn {
  width: 100px;
  min-width: 100px;
  height: 66px;
  margin: 17px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #333a64;
  color: #acb2bf;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;

  i {
    margin-bottom: 5px;
    font-size: 16px;
  }

  &.dis {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.del-whiteboard {
  margin: 0 20px;
  cursor: pointer;

  i {
    margin-right: 5px;
  }
}

.collapse-enter,
.collapse-leave-to {
  height: 0 !important;
}

.header-btn-icon {
  display: inline-block;
  overflow: hidden;
  margin-right: 10px;
  padding-top: 2px;
}

.btm-btns-disturb__disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
